import { render } from "./AlertList.component.vue?vue&type=template&id=b45cce90&scoped=true&ts=true"
import script from "./AlertList.component.vue?vue&type=script&lang=ts"
export * from "./AlertList.component.vue?vue&type=script&lang=ts"

import "./AlertList.component.vue?vue&type=style&index=0&id=b45cce90&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45cce90"]])

export default __exports__